import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import axios from "axios";
import { SignIn, SignUp } from "@clerk/react";
import { UserCheck } from "lucide-react";
import { API, REF_KEY } from "@/lib/api";
import { Logo } from "@/components/Logo";

const Side = () => (
  <div className="relative hidden flex-1 overflow-hidden border-r border-[#1F293D] lg:flex">
    <img src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" alt="Team" className="absolute inset-0 h-full w-full object-cover opacity-30" />
    <div className="absolute inset-0 bg-gradient-to-t from-[#0B0F17] via-[#0B0F17]/70 to-transparent" />
    <div className="relative mt-auto p-12">
      <p className="font-mono text-xs uppercase tracking-[0.2em] text-amber-500">One package · ₹2,000</p>
      <h2 className="mt-3 max-w-md font-display text-4xl font-extrabold leading-tight text-white">Every member you activate puts ₹500 in your wallet.</h2>
    </div>
  </div>
);

const Shell = ({ children }) => (
  <div className="flex min-h-screen bg-[#0B0F17]">
    <Side />
    <div className="flex flex-1 flex-col">
      <div className="p-6"><Link to="/" data-testid="auth-home-link"><Logo /></Link></div>
      <div className="flex flex-1 flex-col items-center justify-center gap-6 px-4 pb-12">{children}</div>
    </div>
  </div>
);

const SponsorCard = () => {
  const [params] = useSearchParams();
  const [sponsor, setSponsor] = useState(null);
  useEffect(() => {
    const ref = params.get("ref") || localStorage.getItem(REF_KEY);
    if (!ref) return;
    localStorage.setItem(REF_KEY, ref.toUpperCase());
    axios.get(`${API}/sponsor/${ref}`).then((r) => setSponsor(r.data)).catch(() => setSponsor(null));
  }, [params]);
  if (!sponsor) return null;
  return (
    <div data-testid="signup-sponsor-card" className="flex w-full max-w-[400px] items-center gap-3 rounded-xl border border-emerald-500/30 bg-emerald-500/10 p-4">
      <UserCheck className="h-5 w-5 text-emerald-400" />
      <p className="text-sm text-slate-200">Invited by <span className="font-semibold text-white">{sponsor.name}</span> <span className="font-mono text-xs text-emerald-400">({sponsor.referral_code})</span></p>
    </div>
  );
};

export const SignInPage = () => (
  <Shell><SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" withSignUp /></Shell>
);

export const SignUpPage = () => (
  <Shell>
    <SponsorCard />
    <SignUp routing="path" path="/sign-up" signInUrl="/sign-in" />
  </Shell>
);
